import axios from 'axios'
import { ElMessage } from 'element-plus';
import caches from './caches'
import auth from './auth'
import config from '../config'

// create an axios instance
const service = axios.create({
	baseURL: config.BASE_URL, // url = base url + request url
	withCredentials: true, // send cookies when cross-domain requests
	timeout: config.REQUEST_TIMEOUT // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		// do something before request is sent
		// config.headers['content-type'] = 'application/json;charset=UTF-8';

		if (caches.jtoken) {
			// let each request carry token
			// ['X-Token'] is a custom headers key
			// please modify it according to the actual situation
			config.headers['jtoken'] = caches.jtoken
		}
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)


function t(str) {
	var filter = [9, 10]
	var res = ''
	var hex
	for (var i = 0; i < str.length; i++) {
		const code = str.charCodeAt(i)
		if (code == 127 || (code < 32 && !filter.includes(code))) {
			hex = '0' + str.charCodeAt(i).toString(16)
			res += '(0x'+hex.substring(hex.length - 2, hex.length)+')'
		} else {
			res += str[i]
		}
	}
	return res
}

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		if (response.headers.jtoken) {
			caches.jtoken = response.headers.jtoken
		}
		if (typeof response.data == 'string') {
			eval(`response.data = ${t(response.data)}`)
		}
		const res = response.data

		// if the custom code is not 20000, it is judged as an error.
		if (res.data == '{}') {
			res.data = {}
		}
		if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
			// re-login
			auth.login().then(resp => {
				if (resp.data.jtoken) caches.jtoken = resp.data.jtoken
				console.log('重放请求：', response.config);
				service(response.config)
			})
		} else if (res.code !== 20000) {
			ElMessage({
				message: res.message.length > 50 ? res.message.substring(0, 50)+'...' : res.message || 'Error',
				type: 'error',
				duration: 5 * 1000
			})

			return Promise.reject(res)
		} else {
			return res
		}
	},
	error => {
		if (!error || !error.response) {
			return Promise.reject(error)
		}
		if (error.response.status === 50008 || error.response.status === 50012 || error.response.status === 50014) {
			// re-login
			auth.logout()
		} else {
			ElMessage({
				message: error.message,
				type: 'error',
				duration: 5 * 1000
			})
		}
		return Promise.reject(error)
	}
)

export function request() {
	const args = arguments[0]
	if (typeof args == 'object') {
		const {url, method = 'post', data} = args
		const isFullUrl = /^https?:\/\//i.test(url)
		return service({
			url: url,
			baseURL: isFullUrl ? '' : config.BASE_URL,
			method: method,
			data
		})
	} else {
		const isFullUrl = /^https?:\/\//i.test(arguments[0])
		return service({
			url: arguments[0],
			baseURL: isFullUrl ? '' : config.BASE_URL,
			method: typeof arguments[1] == 'string' ? arguments[1] : 'POST',
			data: typeof arguments[1] == 'string' ? arguments[2] : arguments[1]
		})
	}
}


export function upload(file, mapping = '/file/upload') {
	return new Promise((resolve) => {
		let formData = new FormData
		formData.append('files', file)
		formData.append('type', 'file')
		request(mapping, formData).then(resp => {
			let fid = resp.data.id
			const url = resp.data.url ? resp.data.url : config.BASE_URL + '/file/download?id=' + fid
			if (resp.data.url || fid) {
				resolve(url)
			} else {
				resolve(resp)
			}
		})
	})
}

export default service

